/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, useMatcapTexture, Shadow } from '@react-three/drei'
import useStore from './store'
import { log } from 'three/examples/jsm/nodes/Nodes.js';


export default function D20(props) {
  const { nodes } = useGLTF('./D20.glb')
  const matcapTexture = useStore((state) => state.matcapTexture);

  const [matcap] = useMatcapTexture('27222B_677491_484F6A_5D657A')

  //604A30_DC9065_212C14_AC9C92
  //9C5B3B_49200A_E9C8AB_DDAB7D
  //1D2424_565F66_4E555A_646C6E
  //27222B_677491_484F6A_5D657A
  
  return (
    <group {...props} dispose={null}>
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Icosphere.geometry}
      rotation={[-0.435, -0.26, 0.066]}
    >
      <meshMatcapMaterial matcap={matcapTexture} />
    </mesh>
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Icosphere001.geometry}
      material={nodes.Icosphere001.material}
      rotation={[-0.435, -0.26, 0.066]}
    ></mesh>
  </group>
  )
}

useGLTF.preload('./D20.glb')
